import { Rule } from "../models/Rule";
import { RuleField } from "../models/RuleField";
import { RuleFieldType } from "../models/RuleFieldType";
import { RuleSchema } from "../models/RuleSchema";


export class DataCleaningTypeGuardService {

    private static readonly RULE_TYPES_THAT_SUPPORT_CHILD_RULES = ['grouping'];

    public static isRule(obj: unknown): obj is Rule {
        return (
            typeof obj === 'object' &&
            obj !== null &&
            '_type' in obj &&
            typeof (obj as any)._type === 'string'
        );
    }

    public static isRuleField(obj: unknown): obj is RuleField {
        return (
            typeof obj === 'object' &&
            obj !== null &&
            'name' in obj &&
            'field_type' in obj &&
            typeof (obj as any).name === 'string' &&
            typeof (obj as any).field_type === 'string'
        );
    }

    public static isRuleSchema(obj: unknown): obj is RuleSchema {
        return (
            typeof obj === 'object' &&
            obj !== null &&
            'type' in obj &&
            'display_name' in obj &&
            'fields' in obj &&
            typeof (obj as any).type === 'string' &&
            typeof (obj as any).display_name === 'string' &&
            Array.isArray((obj as any).fields)
        );
    }

    public static hasDefinedRuleSchemaUi(ruleSchema: RuleSchema): boolean {
        return this.isRuleSchema(ruleSchema)
            && ruleSchema.ui != null
            && typeof ruleSchema.ui === 'object'
            && Array.isArray(ruleSchema.ui.field_groups)
            && ruleSchema.ui.field_groups.length > 0
            && ruleSchema.ui.field_groups.every(group =>
                group != null
                && typeof group === 'object'
                && Array.isArray(group.fields)
                && group.fields.length > 0
            );
    }

    public static supportsChildRules(obj: unknown): boolean {

        // Rule of type "grouping" or 
        // any RuleField with item_schema of type Rule or
        // a RuleSchema with a payload_template that contians "grouping" type
        return (this.isRule(obj) && this.ruleTypeSupportsChildRules((obj as Rule)._type))
            || (this.isPayloadTemplateRuleSchema(obj)  //TODO: make this recursive
                && this.ruleTypeSupportsChildRules((obj as RuleSchema).payload_template?.type))
            || (this.isRuleField(obj) && (obj as RuleField).item_schema?.field_type === RuleFieldType.Rule);

    }

    public static isPayloadTemplateRuleSchema(obj: unknown): boolean {
        return this.isRuleSchema(obj) && (obj as RuleSchema).payload_template != null;
    }

    public static ruleTypeSupportsChildRules(ruleType?: string): boolean {
        return this.RULE_TYPES_THAT_SUPPORT_CHILD_RULES.find(x => ruleType === x) != null;
    }

    public static isNonEmptyRuleObject(value: unknown): value is Record<string, unknown> {
        return (
            typeof value === 'object' &&
            value !== null &&
            !Array.isArray(value) &&
            Object.keys(value).length > 0
        )
    }

}